<template>
<div v-if="hasOauthResponse && showDebugInfo">

    <v-row justify="center" v-if="automatic && !error">
        <v-col cols="12" sm="8" md="6" lg="6" xl="4">
            <v-card width="100%">
                <v-card-title>Processing...</v-card-title>
                <v-card-text class="d-flex justify-center">
                    <v-progress-circular indeterminate size="128" />
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
    <v-row justify="center" v-if="error">
        <v-col cols="12" sm="8" md="6" lg="6" xl="4">
            <v-card width="100%">
                <v-card-title>Error</v-card-title>
                <v-card-text class="d-flex justify-center">

                    {{error}}
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>

    <div v-else>

        <h1>PKCE Callback</h1>

        <v-toolbar>
            <v-btn color="primary" to="/oauth-tester">OAUTH TESTER</v-btn>
        </v-toolbar>

        <pre>{{responseData}}</pre>

        <v-row>
            <v-col>
                <h1>AXIOS POST</h1>
                <div v-for="(prop, key) in state" :key="key" :label="key">{{prop}}</div>
                <v-divider />
                <v-btn @click="tokenRequest">TOKEN REQUEST</v-btn>
            </v-col>
            <v-col>
                <h1>HTML FORM POST (old school)</h1>
                <form method="post" :action="state.token_uri || ''" v-if="!!postOptions">

                    <v-text-field v-for="(key,k) in postOptions" :key="k" :label="k" :name="k" :value="key" />
                    <v-divider />

                    <v-btn type="submit">Submit</v-btn>

                </form>
            </v-col>
        </v-row>

    </div>

    <br />

</div>
</template>

<script>
// @ is an alias to /src
/* eslint-disable */
import axios from 'axios'
import credentials from "@/mixins/credentials-mixin"
import oauthMixin from "./oauth-mixin"
import moment from "moment"
import qs from "query-string"

export default {
    name: "OATHG-PKCE",
    mixins: [credentials, oauthMixin],
    async mounted() {
        if (this.hasOauthResponse) {
            await this.processOAUTHResponse();
        }
    },
    props: {
        automatic: {
            type: Boolean,
            default: true
        },
        automaticDelay: {
            type: Number,
            default: 500
        },
        postLoginDelay: {
            type: Number,
            default: 1000
        },
    },
    data() {
        return {
            state: null,
            responseData: null,
            error: null,
        }
    },

    watch: {
        hasOauthResponse(newVal) {
            
        },
        responseData(newVal) { //result of an http response.
            if (!!newVal.data) {
                
                this.addCredentials(this.state.client_id, newVal.data);
                setTimeout(() => {
                    this.$router.push(this.state.path);
                }, this.postLoginDelay)

            }
        },
    },
    computed: {
        postOptions() {

            return !!this.state ? {
                grant_type: 'authorization_code',
                client_id: this.state.client_id,
                redirect_uri: this.state.redirect_uri,
                code: this.$route.query.code,
                code_verifier: this.state.code_verifier,
                scope: `${this.state.scope} offline_access`,
            } : null;
        }
    },
    methods: {
        async tokenRequest() {
            var self = this;
            try {
                // var result = await axios.post(this.state.token_uri, this.postOptions);
                let formData = new FormData();
                Object.keys(self.postOptions).forEach(e => {
                    formData.append(e, self.postOptions[e]);
                });
                
                self.responseData = await axios({
                    method: 'post',
                    url: self.state.token_uri,
                    data: formData,
                });

            } catch (err) {
                console.error(err);
                this.error = err;
            } finally {}
        },
        async processOAUTHResponse() {
            //Pickup the stored state info. (use it now or never)
            // ;
            try {
                var self = this;
                var query = this.$route.query;
                self.state = JSON.parse(window.localStorage.getItem(query.state));
                if (self.automatic) {
                    setTimeout(await self.tokenRequest, self.automaticDelay);
                }
            } catch (err) {
                console.error(err);
                self.error = err;
            } finally {
                window.localStorage.removeItem(this.$route.query.state);
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// ./src/components/auth/oauth-pkce.vue